export default __webpack_public_path__ + "24d62dfb712b8827ba12c7adaf02ea38.jpg";